


























































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import BirthYearMonthPicker from '@/components/exam/BirthYearMonthPicker.vue'
import MajorSelect from '@/components/exam/MajorSelect.vue'
import NationalSelect from '@/components/exam/NationalSelect.vue'
import SexSelect from '@/components/exam/SexSelect.vue'
import EnrollTextarea from '@/components/exam/EnrollTextarea.vue'
import { getKey } from '@/utils/key'
import type { NormalStudent } from '@/models/enrolls/normalStudent'

@Component({
  components: { BirthYearMonthPicker, MajorSelect, NationalSelect, SexSelect, EnrollTextarea }
})
export default class NormalStudentEnrollForm extends Vue {
  @Prop({ required: true }) value!: NormalStudent
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string
  getKey = getKey

  get form() {
    return this.value
  }

  set form(value: NormalStudent) {
    this.$emit('update:value', value)
  }

  get isLiberalArts() {
    return this.form.examinationCategory === 0
  }

  set isLiberalArts(flag) {
    this.form.examinationCategory = 0
  }

  get isScience() {
    return this.form.examinationCategory === 1
  }

  set isScience(flag) {
    this.form.examinationCategory = 1
  }

  isDisabled(major: string) {
    const { chooseMajor1, chooseMajor2, chooseMajor3, chooseMajor4 } = this.form
    const choosed = [chooseMajor1, chooseMajor2, chooseMajor3, chooseMajor4]
    return choosed.includes(major)
  }
}
